(ns ncr.fragment-types.unsupported-viewer
  (:require
   [ncr.etc.pf :as pf]
   [ncr.widgets.core :as w]
   [ncr.fragment.attachments-backend :as ba]
   [ncr.fragment-types.widgets :as ftw]))

(defn c-viewer [fragment-name {:keys [id] :as attachment} _url close attachments set-preview]
  [:<>
   [ftw/c-toolbar fragment-name attachment close attachments set-preview]
   [pf/c-empty-state
    [pf/c-empty-state-icon
     {:variant :container
      :component [w/c-mdi-icon {:icon :file-cancel-outline}]}]
    [pf/c-title {:heading-level :h4 :size :lg} "This file format is not supported for inline view"]

    (let [reference-id (-> attachments first :reference-id)]
      [pf/c-empty-state-secondary-actions
       [pf/c-button
        {:variant :link
         :on-click #(ba/download! reference-id id :ATTACHMENT)}
        "Download"]

       [pf/c-button
        {:variant :link
         :on-click #(ba/download! reference-id id :INLINE)}
        "Open in new tab"]])]])
